import PropTypes from "prop-types";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import FormLabel from "react-bootstrap/FormLabel";
import { useIntl } from "react-intl";
import FundingAreaContainer from "../fundingArea/FundingAreaContainer";

const IndicatorPanel = ({
  indicatorId,
  indicatorShort,
  indicatorName,
  fieldErrorMessages,
  changeProperty,
  filterSelectedArea,
  isNew
}) => {
  const intl = useIntl();
  const handleChangeProperty = (event) => {
    changeProperty(event.target.name, event.target.value);
  };

  let addProperty = {};
  if (fieldErrorMessages && fieldErrorMessages.indicatorId) {
    addProperty.validationState = "error";
  }

  return (
    <Form horizontal>
      <FormGroup className="mb-3" controlId="indicatorId">
        <Col as={FormLabel} sm={2}>
          {intl.formatMessage({ id: "indicatorList.ID" })}
        </Col>
        <Col sm={10}>
          <FormControl
            name="indicatorId"
            type="text"
            placeholder={intl.formatMessage({ id: "indicatorList.indicatorModalPanel.title.placeholder" })}
            value={indicatorId}
            onChange={handleChangeProperty}
            maxLength={20}
            disabled={!isNew}
          />
        </Col>
      </FormGroup>
      <FormGroup className="mb-3" controlId="indicatorShort">
        <Col as={FormLabel} sm={2}>
          {intl.formatMessage({ id: "indicatorList.IndicatorShort" })}
        </Col>
        <Col sm={10}>
          <FormControl
            name="indicatorShort"
            type="text"
            placeholder={intl.formatMessage({ id: "indicatorList.IndicatorShort" })}
            value={indicatorShort}
            onChange={handleChangeProperty}
            maxLength={40}
          />
        </Col>
      </FormGroup>
      <FormGroup className="mb-3" controlId="indicatorName">
        <Col as={FormLabel} sm={2}>
          {intl.formatMessage({ id: "indicatorList.IndicatorLong" })}
        </Col>
        <Col sm={10}>
          <FormControl
            name="indicatorName"
            type="text"
            placeholder={intl.formatMessage({ id: "indicatorList.IndicatorLong" })}
            value={indicatorName}
            onChange={handleChangeProperty}
          />
        </Col>
      </FormGroup>
      <FormGroup className="mb-3" controlId="indicatorLevel">
        <Col as={FormLabel} sm={2}>
          {intl.formatMessage({ id: "indicatorList.Level" })}
        </Col>
        <Col sm={10}>
          <FundingAreaContainer
            target="indicators"
            filterSelected={(fundingArea, program) => filterSelectedArea(fundingArea, program)}
            preventProjectChoice={true}
            preventProgramInstance={true}
          />
        </Col>
      </FormGroup>
    </Form>
  );
};

IndicatorPanel.propTypes = {
  isNew: PropTypes.bool,
  indicatorName: PropTypes.string,
  indicatorShort: PropTypes.string,
  fundingArea: PropTypes.object,
  program: PropTypes.object,
  changeProperty: PropTypes.func,
  fieldErrorMessages: PropTypes.object,
  filterSelectedArea: PropTypes.func,
  indicatorId: PropTypes.string,
  loadIndicatorListFilter: PropTypes.func
};

export default IndicatorPanel;
